import { getGamesList } from '@modules/games/Game/methods/getGamesList';

export const GAMES_LIST = getGamesList().map((el) => el.toUpperCase());
